import { WireNameValue } from 'scenes/common/api/quote/types';
import {
  getVehicleFinancier,
  getVehicleUnderFinance,
  isVehicleUnderFinance,
} from 'scenes/motor/selectors';
import { Finance, MotorFunnelState } from 'scenes/motor/types';

import {
  OtherAttributes,
  WireMotorQuotePayload,
  WireUnderFinance,
} from '../types';

const mapFinance = (description: string | undefined): Finance => {
  switch (description) {
    case WireUnderFinance.HirePurchaseArrangement:
      return Finance.HirePurchaseArrangement;
    case WireUnderFinance.SecuredLoan:
      return Finance.SecuredLoan;
    case WireUnderFinance.UnsecuredLoan:
      return Finance.UnsecuredLoan;
    case WireUnderFinance.Lease:
      return Finance.Lease;
    default:
      return Finance.NoFinance;
  }
};

export const toFinance = (quote: WireMotorQuotePayload): Finance =>
  mapFinance(
    quote.vehicle.otherAttributes.find(
      (attr) => attr.name === OtherAttributes.UNDERFINANCE
    )?.description
  );

export const toVehicleFinancier = (quote: WireMotorQuotePayload): string =>
  quote.vehicle.otherAttributes.find(
    (attr) => attr.name === OtherAttributes.MORTGAGE
  )?.description || '';

export const toWireFinanceDescription = (state: MotorFunnelState) => {
  switch (getVehicleUnderFinance(state)) {
    case Finance.HirePurchaseArrangement:
      return WireUnderFinance.HirePurchaseArrangement;
    case Finance.SecuredLoan:
      return WireUnderFinance.SecuredLoan;
    case Finance.UnsecuredLoan:
      return WireUnderFinance.UnsecuredLoan;
    case Finance.Lease:
      return WireUnderFinance.Lease;
    default:
      return WireUnderFinance.Unspecified;
  }
};

export const wireVehicleUnderFinanceAttributes = (
  state: MotorFunnelState
): WireNameValue[] =>
  isVehicleUnderFinance(state)
    ? [
        {
          name: OtherAttributes.UNDERFINANCE,
          value: 'true',
          description: toWireFinanceDescription(state),
        },
        {
          name: OtherAttributes.MORTGAGE,
          value: 'true',
          description: getVehicleFinancier(state),
        },
        { name: OtherAttributes.VEHICLESECURITY, value: 'false' },
      ]
    : [
        {
          name: OtherAttributes.UNDERFINANCE,
          value: 'false',
        },
      ];
